/* Sample data for Print Preview — deterministic, realistic Indian invoice data */

const SAMPLE_PRODUCTS = [
  { description: "Software License — Enterprise Edition", hsnCode: "85234929", sku: "SWL-001", taxRate: "18%", unitPrice: 4999, qty: 1 },
  { description: "Cloud Hosting — Annual Plan (Professional)", hsnCode: "99831400", sku: "CHO-002", taxRate: "18%", unitPrice: 1200, qty: 12 },
  { description: "Technical Support & Maintenance", hsnCode: "99834000", sku: "TSM-003", taxRate: "18%", unitPrice: 800, qty: 6 },
  { description: "API Integration Services", hsnCode: "99833000", sku: "AIS-004", taxRate: "18%", unitPrice: 3500, qty: 2 },
  { description: "Data Migration & Setup", hsnCode: "99832000", sku: "DMS-005", taxRate: "18%", unitPrice: 2500, qty: 1 },
  { description: "Custom Module Development", hsnCode: "85234929", sku: "CMD-006", taxRate: "18%", unitPrice: 6000, qty: 3 },
  { description: "Training & Onboarding (per user)", hsnCode: "99839900", sku: "TRN-007", taxRate: "18%", unitPrice: 500, qty: 10 },
  { description: "Annual Subscription — Starter Pack", hsnCode: "99831400", sku: "SUB-008", taxRate: "18%", unitPrice: 8500, qty: 1 },
  { description: "Security Audit & Compliance Review", hsnCode: "99833000", sku: "SAC-009", taxRate: "18%", unitPrice: 4200, qty: 1 },
  { description: "Performance Optimisation Report", hsnCode: "99832000", sku: "POR-010", taxRate: "18%", unitPrice: 1800, qty: 2 },
  { description: "UI/UX Design Consultation", hsnCode: "99839900", sku: "UXD-011", taxRate: "18%", unitPrice: 3000, qty: 4 },
  { description: "Dedicated Server Setup & Config", hsnCode: "85234929", sku: "DSS-012", taxRate: "18%", unitPrice: 7500, qty: 1 },
];

function fmt(num) {
  return num.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function buildItems(count) {
  return Array.from({ length: count }, (_, i) => {
    const p = SAMPLE_PRODUCTS[i % SAMPLE_PRODUCTS.length];
    const qty = (i % 4) + 1;
    const unitPrice = p.unitPrice;
    const amount = qty * unitPrice;
    const discount = Math.round(amount * 0.05);
    const netAmount = amount - discount;
    const taxAmount = Math.round(netAmount * 0.18);
    return {
      index: i + 1,
      description: p.description,
      hsnCode: p.hsnCode,
      sku: `${p.sku}-${String(i + 1).padStart(2, "0")}`,
      quantity: qty,
      unitPrice: fmt(unitPrice),
      taxRate: p.taxRate,
      discount: fmt(discount),
      netAmount: fmt(netAmount),
      taxAmount: fmt(taxAmount),
      amount: fmt(amount),
      cgst: fmt(taxAmount / 2),
      sgst: fmt(taxAmount / 2),
    };
  });
}

export function generateSampleData(itemCount = 7) {
  const items = buildItems(itemCount);

  const subtotal = items.reduce((s, it) => s + parseFloat(it.amount.replace(/,/g, "")), 0);
  const discount = subtotal * 0.05;
  const taxable = subtotal - discount;
  const cgst = taxable * 0.09;
  const sgst = taxable * 0.09;
  const tax = cgst + sgst;
  const total = taxable + tax;

  const gstSummary = [
    {
      hsnCode: "85234929",
      description: "Software / Digital Goods",
      taxableValue: fmt(taxable * 0.6),
      gstRate: "18%",
      cgst: fmt(taxable * 0.6 * 0.09),
      sgst: fmt(taxable * 0.6 * 0.09),
      totalTax: fmt(taxable * 0.6 * 0.18),
    },
    {
      hsnCode: "99831400",
      description: "Professional Services",
      taxableValue: fmt(taxable * 0.4),
      gstRate: "18%",
      cgst: fmt(taxable * 0.4 * 0.09),
      sgst: fmt(taxable * 0.4 * 0.09),
      totalTax: fmt(taxable * 0.4 * 0.18),
    },
  ];

  return {
    // Company
    companyName: "Acme Technologies Pvt. Ltd.",
    companyAddress: "42, Innovation Park, Electronic City\nBangalore, Karnataka — 560 100",
    companyGST: "29AABCA1234A1Z5",
    companyPAN: "AABCA1234A",
    companyPhone: "+91 80 6789 1234",
    companyEmail: "billing@acmetech.in",
    companyLogo: "",

    // Invoice details
    invoiceNumber: "INV/2025-26/0542",
    invoiceDate: "15 Jan 2025",
    dueDate: "14 Feb 2025",
    poNumber: "PO-2025-8821",
    invoiceType: "Tax Invoice",

    // Customer
    customerName: "Globex Solutions Pvt. Ltd.",
    customerAddress: "789, Nehru Place\nNew Delhi — 110 019",
    customerGST: "07AACCG5678B1ZD",
    customerPAN: "AACCG5678B",
    customerPhone: "+91 11 4567 8900",
    customerEmail: "accounts@globex.in",

    // Nested objects
    company: {
      name: "Acme Technologies Pvt. Ltd.",
      address: "42, Innovation Park, Bangalore 560 100",
      gst: "29AABCA1234A1Z5",
      pan: "AABCA1234A",
      phone: "+91 80 6789 1234",
      email: "billing@acmetech.in",
    },
    invoice: {
      number: "INV/2025-26/0542",
      date: "15 Jan 2025",
      dueDate: "14 Feb 2025",
      po: "PO-2025-8821",
    },
    customer: {
      name: "Globex Solutions Pvt. Ltd.",
      address: "789, Nehru Place, New Delhi 110 019",
      gst: "07AACCG5678B1ZD",
      phone: "+91 11 4567 8900",
      email: "accounts@globex.in",
    },

    // Line items
    items,

    // Totals
    subtotal: fmt(subtotal),
    discount: fmt(discount),
    taxableAmount: fmt(taxable),
    cgst: fmt(cgst),
    sgst: fmt(sgst),
    igst: fmt(tax),
    tax: fmt(tax),
    taxAmount: fmt(tax),
    total: fmt(total),
    grandTotal: fmt(total),
    amountInWords: "Rupees " + Math.round(total).toLocaleString("en-IN") + " Only",

    // Page info (overridden by preview generator per page)
    currentPage: 1,
    totalPages: 1,

    // GST summary
    gstSummary,

    // Generic placeholders
    terms: "Payment due within 30 days. Late payments subject to 1.5% per month interest.",
    bankName: "HDFC Bank Ltd.",
    accountNumber: "50100123456789",
    ifsc: "HDFC0001234",
    branch: "Electronic City, Bangalore",
    authorizedSignatory: "Rajesh Kumar",
    note: "Thank you for your business!",
  };
}
